import React from "react";
import { Skeleton } from 'primereact/skeleton';

import RectangleRowWithNineColSkeleton from "./RectangleRowWith9column";


const AuditProductSkeleton = () => { 
    return(
        <div className="audit-product mb-3">
             <div className="flex flex-column">
                <div className="flex flex-row justify-content-between">
                    <Skeleton width="17rem" className=""></Skeleton>
                    <Skeleton width="12rem" className=""></Skeleton>
                </div>
                <div className="mt-2 mb-0 pb-2 flex  flex-row justify-content-between">
                    <div className="flex flex-row justify-content-between p-card col-4 mr-3">
                        <Skeleton shape="rectangle" height="2rem" width="15rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="15rem" className="mb-2 mr-2" />
                    </div>
                    <div className="flex flex-row p-card col-8">
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                        <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />                   
                    </div>
                </div>
                <div className="flex flex-column">
                    <Skeleton width="12rem" className=""></Skeleton>
                    <div className="my-2 p-card pb-2">
                        <div className="flex flex-column">
                            <RectangleRowWithNineColSkeleton />
                            <Skeleton width="10rem" className="mb-2 mt-3 mr-3"></Skeleton>
                            <div className="flex">
                                <Skeleton width="15rem" className="mb-2 mt-3 mr-3"></Skeleton>
                                <div className="col-9 flex flex-row ml-6">
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                </div>
                            </div>
                            <div className="flex mt-2">
                                <Skeleton width="15rem" className="mb-2 mt-3 mr-3"></Skeleton>
                                <div className="col-9 flex flex-row ml-6">
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                    <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" /> 
                                </div>
                            </div>
                            {/* <RectangleRowWithNineColSkeleton />
                            <RectangleRowWithNineColSkeleton /> */}
                        </div>
                    </div>
                </div>
                <div className="mt-2 flex flex-column">
                    <Skeleton width="12rem" className=""></Skeleton>
                    <div className="my-2 p-card pb-2">
                        <div className="flex flex-column">
                            <RectangleRowWithNineColSkeleton />
                        </div>
                    </div>
                </div>
                <div className="mt-2 flex flex-column">
                    <Skeleton width="12rem" className=""></Skeleton>
                    <div className="my-2 p-card pb-2 flex flex-row col-12 justify-content-between">
                        <div className="flex flex-column col-6 pb-0">
                            <div className="flex flex-row justify-content-between">
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                            </div>
                            <div className="flex flex-row justify-content-between">
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                            </div>
                            <div className="flex flex-row justify-content-between">
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                            </div> 
                            <div className="flex flex-row justify-content-between">
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                                <Skeleton shape="rectangle" height="2rem" width="12rem" className="mb-2 mr-2" />
                            </div>
                        </div>
                        <div className=" flex col-6">
                            <Skeleton width="100%" height="auto"></Skeleton>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-content-center mt-2">
                    <Skeleton shape="rectangle" height="2rem" width="10rem" className="mb-2" />
                </div>
            </div>
        </div>
    )
}

export default AuditProductSkeleton